import React from 'react';

const map = new Map<string, React.RefObject<any>>();

const defineRef = <T>(key: string): React.RefObject<T> => {
  const ref = React.createRef<T>();
  map.set(key, ref);
  return ref;
};

const readRef = <T>(key: string): React.RefObject<T> | undefined =>
  map.get(key) as React.RefObject<T>;

const iterateRef = <T>(
  callback: (value: React.RefObject<T>, key: string) => void,
) => map.forEach((value, key) => callback(value, key));

export const useDynamicRefs = <T>(): {
  defineRef: typeof defineRef<T>;
  readRef: typeof readRef<T>;
  iterateRef: typeof iterateRef<T>;
  refMap: typeof map;
} => ({
  defineRef,
  readRef,
  iterateRef,
  refMap: map,
});
